import { render } from "./FooterContent.vue?vue&type=template&id=46ec9649"
import script from "./FooterContent.vue?vue&type=script&lang=js"
export * from "./FooterContent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rswenson/code/arch/surfacing/src/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__